export default class CreditModel {
    constructor (
        _id,
        _customer = {},
        _creditLine = { code: 0, name: '' },
        _limit = 0,
        _status = { code: 0, name: '' },
    ){
        this.id  = _id;
        this.customer   = _customer; 
        this.creditLine = _creditLine;
        this.limit  = _limit;
        this.status = _status;

    }
}
  